<!-- -------- desktop header --------- -->
<div class="header d-none d-lg-block" [ngClass]="{ scrolled: isScrolled }">
  <div class="container">
    <div class="d-flex justify-content-start align-items-center w-100 gap-3">
      <a class="cursor-pointer d-flex align-items-center p-0" routerLink="/{{ currentLanguage }}/" #navigation (click)="addActive($event, '')">
        <svg-icon src="/assets/images/svg-icons/token.svg" [svgStyle]="{ 'width.px': '53', 'height.px': '53' }"></svg-icon>
      </a>

      <div class="d-flex align-items-center gap-2">
        <!-- dropdown 1-->
        <div class="btn-group" dropdown>
          <div dropdownToggle type="button" class="navigationMenu dropdown-toggle">
            <p class="mb-0 lh-1">{{ 'top_navigation.nav_resources' | translate }}</p>
            <svg-icon class="arrowIcon" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu subNav" role="menu">
            <li [ngClass]="{'in-active':!item.externalLink}" (click)="redirectToExternalLink(item.externalLink)" class="subMenu" role="menuitem" *ngFor="let item of resourceSubMenu">
              <span *ngIf="!item.externalLink" class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
              <a *ngIf="item.externalLink"  class="" [href]="item.externalLink" title="{{ item.navName | translate }}" target="_blank" [innerHTML]="item.navName | translate"></a>
               <a *ngIf="!item.externalLink"  class="" href="#" title="{{ item.navName | translate }}" target="_blank" [innerHTML]="item.navName | translate"></a>
            </li>
          </ul>
        </div>
        <a routerLink="/{{currentLanguage}}/claim" title="claim" class="navigationMenu">
          <span>{{ 'top_navigation.nav_claim' | translate }}</span>
        </a>

        <!-- dropdown 2-->
        <!-- <div class="btn-group" dropdown>
          <div dropdownToggle type="button" class="navigationMenu dropdown-toggle">
            <p class="mb-0 lh-1">{{ 'top_navigation.nav_products' | translate }}</p>
            <svg-icon class="arrowIcon" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu subNav" role="menu">
            <li class="subMenu" role="menuitem" *ngFor="let item of productSubMenu">
              <a class="" href="#" title="{{ item.navName | translate }}" target="_blank" [innerHTML]="item.navName | translate"></a>
            </li>
          </ul>
        </div> -->
       <a  target="_blank"  title="products" class="navigationMenu inActive">
          <span class="inActive">{{ 'top_navigation.nav_products' | translate }}</span>
          <span class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
        </a>
        <a  target="_blank"  title="bridge" class="navigationMenu inActive">
          <span class="inActive">{{ 'top_navigation.nav_bridge' | translate }}</span>
          <span class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
        </a>
         <a  (click)="addActive($event, '')" title="staking" class="navigationMenu inActive">
          <span class="inActive">{{ 'top_navigation.nav_staking' | translate }}</span>
          <span class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
         </a>
        <a title="shop" class="navigationMenu inActive">
          <span class="inActive">{{ 'top_navigation.nav_shop' | translate }}</span>
          <span class="comingSoon">{{ 'misc.coming_soon' | translate }}</span>
        </a>
      </div>

      <div class="d-flex flex-grow-1"></div>

      <div class="d-flex align-items-center justify-content-end gap-2">
        <!-- ---------- Social network --------- -->

        <span class="social-wrap gap-2">
          <a *ngFor="let item of social" href="{{ item.link }}" class="navigationMenu" target="_blank">
            <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
          </a>
        </span>

        <!--- buynow wallet/address --->
        <div class=" btn btn-primary " (click)="redirectToExternalLink('https://app.uniswap.org/swap?outputcurrency=0x93aA0ccD1e5628d3A841C4DbdF602D9eb04085d6')">{{ 'widget.buy_now' | translate }}</div>

        <!-- language dropdown -->

        <div class="btn-group" dropdown>
          <div dropdownToggle type="button" class="dropdown-toggle navigationMenu">
            <p class="mb-0 text-uppercase lh-1">{{ selectedLanguage.value }}</p>
            <svg-icon class="arrowIcon" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList" (click)="changeLanguage(lang.value)">
              <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" loading="lazy" />
              <span>{{ lang.native_name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- -------- mobile header --------- -->

<div class="header d-block d-lg-none" [ngClass]="{ scrolled: isScrolled }">
  <div class="d-flex justify-content-between align-items-center flex-grow-1 w-100 gap-2">
    <div class="d-flex justify-content-start align-items-center flex-grow-1">
      <a class="cursor-pointer p-0" routerLink="/{{ currentLanguage }}/" (click)="openCloseMenu()" #navigation>
        <img src="/assets/images/svg-icons/token.svg" alt="token" height="51" />
      </a>
    </div>

    <div class="d-flex align-items-center gap-2">

      <!---language dropdown-->
      
      <div class="btn-group" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle navigationMenu">
          <p class="mb-0 text-uppercase lh-1">{{ selectedLanguage.value }}</p>
          <svg-icon class="arrowIcon" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
        </div>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList" (click)="changeLanguage(lang.value)">
              <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" loading="lazy" />
              <span>{{ lang.native_name }}</span>
            </li>
          </ul>
          
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList" (click)="changeLanguage(lang.value); openCloseMenu()">
            <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" loading="lazy" />
            <span>{{ lang.native_name }}</span>
          </li>
        </ul>
      </div>

      <div class="menu-btn d-flex align-items-center " (click)="openCloseMenu()">
        <span class="fw-bold text-uppercase m-0 font-16 pe-2 pt-1">MENU</span>
        <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 16 }"></svg-icon>
      </div>
    </div>
  </div>

  <div class="menu-overlay" *ngIf="showMenu">
    <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">

      <!--- social icons -->
      <div class="d-flex justify-content-end align-items-center">
        <span class="social-wrap gap-2">
          <a *ngFor="let item of social" href="{{ item.link }}" class=" mb-0" target="_blank" >
            <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" height="30" width="30" />
          </a>
        </span>
             <!-- theme icon -->
          <!-- <div type="button" class=" ms-2 navigationMenu">
          
            <svg-icon class="arrowIcon" src="./assets/images/svg-icons/theme.svg" [svgStyle]="{ 'width.px': '20', 'height.px': '30' }"></svg-icon>
          </div> -->
      </div>
    <div class="menu-btn d-flex align-item-center" (click)="openCloseMenu()">
      <span class="me-2 fw-bold">Menu</span>
      <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg" [svgStyle]="{ 'width.px': 16, 'height.px': 12 }"></svg-icon>
    </div>
 
  </div>

  <div class="menu-overlay" *ngIf="showMenu">
    <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">
         <!--- social links --->
      <span class="social-wrap d-flex align-items-center justify-content-end gap-2 mb-4 pb-2">
        <a *ngFor="let item of social" href="{{ item.link }}" class="navigationMenu" target="_blank">
          <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
        </a>
         <!-- theme icon -->
         <div type="button" class="navigationMenu theme-btn">
          <svg-icon class="arrowIcon " src="./assets/images/svg-icons/theme.svg" [svgStyle]="{ 'width.px':'16', 'height.px':'16' }"></svg-icon>
         </div>
      </span>
      <!--- menu links-->
      <div class="d-flex flex-column justify-content-center text-end align-items-end w-100">
        
        <a class="" routerLink="/{{ currentLanguage }}/claim" (click)="addActive($event, 'claim')" title="claim">{{ 'top_navigation.nav_claim' | translate }}</a>
        <a class="disabled-link" routerLink="/{{ currentLanguage }}/staking" title="staking" (click)="openCloseMenu()" routerLinkActive="active">{{ 'top_navigation.nav_staking' | translate }}</a>
        <!-- <a class="" *ngFor="let item of navigations" routerLink="/{{ currentLanguage }}" fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName); openCloseMenu()" title="{{ item.routeName }}">{{ item.navName | translate }} </a> -->
        <a class="disabled-link" routerLink="/{{ currentLanguage }}" (click)="addActive($event, 'bridge')" title="bridge">{{ 'top_navigation.nav_bridge' | translate }}</a>
        <a class="disabled-link" routerLink="/{{ currentLanguage }}" (click)="addActive($event, 'products')" title="products">{{ 'top_navigation.nav_products' | translate }}</a>

        <p class="nav-title mb-0 mt-4 mb-2 text-uppercase">{{"top_navigation.nav_resources" | translate}}</p>
        <a class="" [ngClass]="{'disabled-link':!item.externalLink}" [href]="item.externalLink" *ngFor="let item of resourceSubMenu" title="{{item.navName | translate}}" target="_blank" [innerHTML]="item.navName | translate"></a>

     
      </div>

   

    

      <div class="rounded-3 btn btn-primary  mt-4 mx-auto" (click)="redirectToExternalLink('https://app.uniswap.org/swap?outputcurrency=0x93aA0ccD1e5628d3A841C4DbdF602D9eb04085d6'); openCloseMenu()">{{ 'widget.buy_now' | translate }}</div>
    </div>
  </div>
</div>
